/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useCallback, useEffect, useRef } from "react";

const useThrottle = (fn, delay, dep = []) => {
  const { current } = useRef({ fn, timer: null });
  useEffect(() => {
    current.fn = fn;
  }, [fn]);

  return useCallback(
    (...args) => {
      if (!current.timer) {
        current.timer = setTimeout(() => {
          delete current.timer;
        }, delay);

        current.fn.call(this, ...args);
      }
    },
    [delay, ...dep],
  );
};

export default useThrottle;

export const throttle = (fn, delay, disabled = false) => {
  let timer = null;
  return (...args) => {
    if (!timer) {
      timer = setTimeout(() => {
        if (!disabled) {
          fn.call(this, ...args);
        }

        clearTimeout(timer);
        timer = null;
      }, delay);
    }
  };
};
